/** 1.99.5 · Huella del esquema de la base de este equipo (para ver si un puesto y el servidor son compatibles). */
import { APPEND_ONLY_TABLES, AppSchema, IDEMPOTENT_PUT_TABLES, WRITABLE_TABLES } from "@/offline/schema";
import { env } from "@/lib/env";
import { schemaSignature } from "./compat";

let cached: string | null = null;
export function lanSchema(): string {
  if (cached) return cached;
  let sig: string | null = null;
  const extra = [...[...WRITABLE_TABLES].map((t) => `w:${t}`), ...[...APPEND_ONLY_TABLES].map((t) => `a:${t}`), ...[...IDEMPOTENT_PUT_TABLES].map((t) => `i:${t}`)];
  try { sig = schemaSignature((AppSchema as unknown as { toJSON?: () => unknown }).toJSON?.(), extra); } catch { sig = null; }
  // Sin huella, se pide la misma versión exacta (como antes).
  cached = sig ?? `v:${env.version}`;
  return cached;
}
